import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Config payload for programmatic banner updates. 20/07/2026 DW */
export interface GeneralResponseConfig {
  message: string;
  isSuccess: boolean;
}

/**
 * Reusable popup notification banner (bank-suite general-response pattern).
 * Gray #e0e0e0 body, peach close, centered bold message. 20/07/2026 DW
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'auth-suite-services-app-general-response',
  templateUrl: './general-response.component.html',
  styleUrls: ['./general-response.component.scss'],
  standalone: true,
  // Dropped Material card/icon so banner stays full-width under customizer FAB 20/07/2026 DW
  imports: [CommonModule],
})
export class GeneralResponseComponent {
  @Input() message = '';
  @Input() showMsg = false;
  @Input() isSuccess = true;

  @Input() set config(value: GeneralResponseConfig | null | undefined) {
    if (value) {
      this.message = value.message || '';
      this.isSuccess = value.isSuccess;
    }
  }

  @Output() showMsgEvent = new EventEmitter<boolean>();

  hideMessage(): void {
    this.showMsg = false;
    this.showMsgEvent.emit(false);
  }

  showMessage(message: string, isSuccess = true): void {
    this.message = message;
    this.isSuccess = isSuccess;
    this.showMsg = true;
    this.showMsgEvent.emit(true);
  }
}
